export enum ControleEstoqueSerieStatusEnum {
  Disponivel = 1,
  Reservado = 2,
  Baixado = 3,
}
